<mat-form-field appearance="fill" class="data-protection-rule-select">
  <mat-label>
    <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.dataProtectionRule"></sc-dictionary-label>
  </mat-label>
  <mat-select [formControl]="formControl" [required]="required">
    @for (rule of dataProtectionRules; track rule) {
      <mat-option [value]="rule.id">
        {{rule.name}}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
